module.exports = __webpack_public_path__ + "img/map.68568dbf.svg";